import "./PulseFABButton.css";
import {Link, useLocation} from "react-router-dom";
import grandLogo from '../../assets/grand/GRAN-D-elementos-02.svg'

function PulseFabButton(props) {
    const {pathname} = useLocation()
    
    if(pathname && pathname === "/grand") return null
    return (
        <div className="pulseFabButton-container">
            <Link
                className="pulseFabButton-button"
                to='/grand'
                target="_blank"
            >
                <img src={grandLogo} alt='GranD' />
            </Link>
        </div>
    );
}

export default PulseFabButton;